import React, { useEffect, useState } from 'react';
import { BarChart, Bar, XAxis, YAxis, CartesianGrid, Tooltip, ResponsiveContainer, Cell, LabelList } from 'recharts';
import { Euro } from 'lucide-react';
import { dashboardAPI } from '../../lib/api';
import { Card, CardContent, CardHeader, CardTitle } from '../ui/card';
import { Select, SelectContent, SelectItem, SelectTrigger, SelectValue } from '../ui/select';
import { formatCurrency, formatK, ROLE_LABELS } from './format';

const COLORS = ['#D32F2F', '#1976D2', '#388E3C', '#F57C00', '#7B1FA2', '#0097A7', '#C2185B', '#5D4037'];

export const SalesBySellerChart = () => {
    const [period, setPeriod] = useState('year');
    const [rows, setRows] = useState([]);
    useEffect(() => { dashboardAPI.getSalesByUser(period).then(r => setRows(r.data || [])).catch(() => setRows([])); }, [period]);
    const data = rows.filter(r => r.total_won > 0).map(r => ({ name: r.name || '', full: r.name, role: r.role, value: r.total_won || 0, count: r.won_count || 0 }));

    return (
        <Card data-testid="sales-by-user">
            <CardHeader className="flex flex-row flex-wrap items-start justify-between gap-3 space-y-0">
                <div>
                    <CardTitle className="font-heading uppercase text-lg flex items-center gap-2"><Euro size={18} /> Vendite confermate per venditore</CardTitle>
                    <p className="text-sm text-muted-foreground mt-1">Commerciali, area manager e admin con vendite nel periodo.</p>
                </div>
                <Select value={period} onValueChange={setPeriod}>
                    <SelectTrigger className="w-[160px]" data-testid="sales-by-user-period"><SelectValue /></SelectTrigger>
                    <SelectContent>
                        <SelectItem value="month">Mese in corso</SelectItem>
                        <SelectItem value="year">Anno in corso</SelectItem>
                        <SelectItem value="all">Sempre</SelectItem>
                    </SelectContent>
                </Select>
            </CardHeader>
            <CardContent>
                {data.length === 0 ? (
                    <p className="text-sm text-muted-foreground py-10 text-center">Nessuna vendita nel periodo selezionato.</p>
                ) : (
                    <ResponsiveContainer width="100%" height={Math.max(160, data.length * 44 + 30)}>
                        <BarChart data={data} layout="vertical" margin={{ top: 4, right: 48, left: 4, bottom: 0 }}>
                            <CartesianGrid strokeDasharray="3 3" horizontal={false} />
                            <XAxis type="number" tickFormatter={formatK} fontSize={12} />
                            <YAxis type="category" dataKey="name" width={130} fontSize={12} interval={0} />
                            <Tooltip
                                formatter={(v, n, p) => [`${formatCurrency(v)} · ${p.payload.count} veicoli`, 'Venduto']}
                                labelFormatter={(l, p) => (p?.[0] ? `${p[0].payload.full} (${ROLE_LABELS[p[0].payload.role] || ''})` : l)}
                            />
                            <Bar dataKey="value" radius={[0, 4, 4, 0]} barSize={26}>
                                {data.map((_, i) => <Cell key={i} fill={COLORS[i % COLORS.length]} />)}
                                <LabelList dataKey="value" position="right" formatter={(v) => (v ? formatK(v) : '')} fontSize={11} />
                            </Bar>
                        </BarChart>
                    </ResponsiveContainer>
                )}
            </CardContent>
        </Card>
    );
};
